module.exports = __webpack_public_path__ + "img/18.37737ee6.jpg";